import { GuardedDeletionService, StandService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StandCreateDto,
  StandDto,
  StandExcelDownloadDto,
  StandUpdateDto,
} from '../proxy/planning/dtos/stand';
import { STAND_CONFIG, STAND_FIELDS } from './stand.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-stand',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StandService, ConfirmationService],
  templateUrl: './stand.html',
  styleUrl: './stand.scss',
})
export class Stand extends BaseHierarchicalCrudComponent<
  StandDto,
  StandCreateDto,
  StandUpdateDto,
  StandExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(StandService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Stand', ids),
  };
  config = STAND_CONFIG;
  fields = STAND_FIELDS;

  protected prepareUpdateDto(data: any, selected: StandDto): StandUpdateDto {
    return {
      name: data.name,
      standArea: data.standArea,
      gisArea: data.gisArea,
      isStrategic: data.isStrategic,
      hasNearbyPopulation: data.hasNearbyPopulation,
      currentCycle: data.currentCycle,
      currentRotation: data.currentRotation,
      isPefcCertified: data.isPefcCertified,
      isFscCertified: data.isFscCertified,
      deactivationReasonId: data.deactivationReasonId,
      deactivationDate: data.deactivationDate,
      forestrySituationId: data.forestrySituationId,
      locationId: data.locationId,
      previousSoilUseId: data.previousSoilUseId,
      propertyId: data.propertyId,
      standTypeId: data.standTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Stand';
  }
}
